var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('router-view',{attrs:{"toolPartners":_vm.toolPartners,"activeToolData":_vm.activeToolData,"filterData":_vm.filterData,"terms":_vm.terms},on:{"onSelectTool":_vm.onSelectTool,"onApplyFilter":_vm.onApplyFilter,"onSearch":_vm.onSearch}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }